import styled from 'styled-components';
import { CalendarContainer } from 'react-datepicker';
import { getColor, getColorShade, getElevation, getThemeProp } from '../../../../src/styled/utils';
export const Container = styled(CalendarContainer) `
  display: flex;
  width: 100%;
  font-size: initial;
  font-family: initial;
  background-color: ${getColor('surface')};
  border: 1px solid ${getColorShade('onSurface', 'outline')};
  border-radius: ${getThemeProp('borderRadius')}px;
  box-shadow: ${getElevation(16)};
`;
